import { render } from "./NewsArticleContent.vue?vue&type=template&id=5f55effc"
import script from "./NewsArticleContent.vue?vue&type=script&lang=js"
export * from "./NewsArticleContent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__